import { render } from "./myCounsel.vue?vue&type=template&id=97fbc80c&ts=true"
import script from "./myCounsel.vue?vue&type=script&lang=ts&config=true"
export * from "./myCounsel.vue?vue&type=script&lang=ts&config=true"

import "./myCounsel.vue?vue&type=style&index=0&id=97fbc80c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__